import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ReportsService } from '../../../../services/reports.service';
import { NextPage } from '@cvx/nextpage';
import { saveAs } from 'file-saver';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-assigned-to-cai',
    imports: [TableModule, CommonModule, NextPage, RouterModule, FormsModule],
    templateUrl: './assigned-to-cai.component.html',
    styleUrl: './assigned-to-cai.component.scss'
})
export class AssignedToCaiComponent {
  newUserId: string = '';
  userCai: string = '';
  facilityID: string = '';
  showTab: boolean = false;
  userVerified: boolean = false;
  userDoesNotExist: boolean = false;
  showTable: boolean = false;
  assignedCaiReport: any;
  assignedCaiReportData: any[] = [];

  selectedTab: string = 'operations';
  isClear: boolean = false;

  constructor(private report: ReportsService, public commonService: CommonService, private notificationService: NotificationService) {
    this.facilityID = this.commonService.getCurrentFacility();
  }

  verifyUser(): void {
    if (this.newUserId) {
      this.report.validateInspectorCaiReport(this.newUserId).subscribe({
        next: (data: any) => {
          this.assignedCaiReport = data.userDetails;
          this.userCai = data.userDetails.cai;
          this.userVerified = true;
          this.userDoesNotExist = false;
          this.isClear = true;
        },
        error: (error: any) => {
          this.userDoesNotExist = true;
          this.userVerified = false;
          console.error('Error verifying user:', error);
        }
      });
    }
    else {
      this.notificationService.showError("Please enter a User email");
    }
  }

  runReport() {
    this.showTab = true;

    this.selectedTab = 'operations'; // Default to operations tab
    this.getassignedCaiReport()
  }
  getassignedCaiReport(): void {
    this.report.getCaiReport(this.selectedTabFlag(), this.facilityID, this.userCai, this.userCai).subscribe({
      next: (data: any[]) => {
        this.assignedCaiReportData = data;
        this.showTable = true;
      },
      error: (error: any) => {
        this.assignedCaiReportData = [];
        this.showTable = false;

        console.error('Error fetching report:', error);
      }
    });
  }

  clearUserID(): void {
    this.newUserId = '';
    this.userVerified = false;
    this.userDoesNotExist = false;
    this.showTable = false;
    this.assignedCaiReportData = [];
    this.showTab = false;
    this.isClear = false;
  }

  onTabClick(tab: string): void {
    this.selectedTab = tab;
    this.getassignedCaiReport()
  }

  selectedTabFlag(): string {
    switch (this.selectedTab) {
      case 'operations': return 'o';
      case 'inspection': return 'i';
      case 'engineering': return 'e';
      case 'oa': return 'a';
      default: return 'i';
    }
  }

  return(): void {
    this.showTable = false;
  }

  exportToExcel(): void {


    const facilityId = localStorage.getItem('current_facility_id');

    if (!facilityId) {
      console.error('Facility ID is missing.');
      return;
    }

    let params = {
      flag: this.selectedTabFlag(),
      facilityId: facilityId,
      userCAI: this.userCai,
      CAI: this.userCai
    }
    this.report.getCaiReportExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, `TLR-Assigned2CAI_${this.selectedTab}.xlsx`);
          }

        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      })
  }
}
